import React from "react";
const Comp1 = React.lazy(() => import("./PPOverview"));
const Comp2 = React.lazy(() => import("./PPActivity"));
const Comp3 = React.lazy(() => import("./PPPoints"));
const Comp4 = React.lazy(() => import("./PPRankings"));
const Comp5 = React.lazy(() => import("./PPSlams"));
const Comp6 = React.lazy(() => import("./PPTitles"));
import { useLazyLoad } from "../../helpers/hooks";

import {
  PPOverviewProps,
  PPActivityProps,
  PPPointsType,
  PPRankingsProps,
  PPSlamsType,
  PPTitlesType
} from "./types";

export const PPOverview = (props: PPOverviewProps) =>
  useLazyLoad(<Comp1 {...props} />);
export const PPActivity = (props: PPActivityProps) =>
  useLazyLoad(<Comp2 {...props} />);
export const PPPoints = (props: PPPointsType) =>
  useLazyLoad(<Comp3 {...props} />);
export const PPRankings = (props: PPRankingsProps) =>
  useLazyLoad(<Comp4 {...props} />);
export const PPSlams = (props: PPSlamsType) =>
  useLazyLoad(<Comp5 {...props} />);
export const PPTitles = (props: PPTitlesType) =>
  useLazyLoad(<Comp6 {...props} />);
